import React from 'react'
import './style.scss';

function Loader({ type }) {
    switch (type) {
        case 'roller':
            return (
                <div className="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            )
        case 'ellipsis':
            return (
                <div className="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
            )
        default:
            return <div>Invalid type of roller</div>
    }

}

export default Loader
